//@flow

// Vendors
import React from 'react';
import {useDispatch} from 'react-redux';

// Components
import {Modal} from '../../../../../modals';
import Trans from '../../../../../Trans/Trans';

// Actions
import {closeModal} from '../../../../../../../reducers/modal/modalActions';

// Styles
import '../dps-learn-more-modal.scss';
import {TxButton, TxButtonMode} from "texkit-ui";

const DpsUSCitizenshipDocumentModal = () => {
  const dispatch = useDispatch();
  // Switch to adjusted SCSS if on iOS device
  const userAgent = window.navigator.userAgent.toLowerCase();
  const ios = /iphone|ipod|ipad/.test( userAgent );
  return (
    <Modal
      name="DpsUSCitizenshipDocumentModal"
      className={
        ios ? "learn-more modal ios" : "learn-more modal"
      }
    >
      <div>
        <h2 className="h2 modal-header">
          <Trans file="dps" id="dps_USCitizenshipDocument_Modal_Title"/>
        </h2>
        <p className="modal-description">
          <Trans file="dps" id="dps_USCitizenshipDocument_Modal_Desc1"/>
          <Trans file="dps" id="dps_USCitizenshipDocument_Modal_Desc2"/>
          <Trans file="dps" id="dps_USCitizenshipDocument_Modal_Desc3"/>
        </p>
      </div>

      <TxButton className="modal-close-button"
                mode={TxButtonMode.Primary}
                type="submit"
                onClick={() => dispatch(closeModal("DpsUSCitizenshipDocumentModal"))}
      >
        <Trans file="Labels" id="gotIt" fallback="OK, got it"/>
      </TxButton>
    </Modal>
  );
};

export default DpsUSCitizenshipDocumentModal;
